import { useContext, useEffect, useRef, useState } from "react";
import "./Header.css";
import { ConfigContext } from "../../assets/contexts/configContext";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  ABOUT_US_PAGE_LINK,
  CART_MAIN_LINK,
  CATALOG_MAIN_LINK,
  EN_SITE_URL,
  FAVORITE_LINK,
  PHONE,
  RU_SITE_URL,
  SELL_TO_US_PAGE_LINK
} from "../../assets/utils/constants";
import { CartIcon, CloseIcon, LAND_DROP_ARROW, LogoIcon, MenuIcon, SearchIcon } from "../../assets/icons/icons";
import mainApi from "../../assets/api/MainApi";
import CatalogDrop from "./CatalogDrop/CatalogDrop";
import MenuPopup from "./MenuPopup/MenuPopup";
import { CartContext } from "../../assets/contexts/cartContext";
import useScrollDirection from "../../assets/hooks/useScrollDirection";
import { getURLRelativePath, isExternalURL } from "../../assets/utils/utils";
import Search from "../Search/Search";
import useWindowSize from "../../assets/hooks/useWindowSize";
import { motion } from "framer-motion";
import { CallBackContext } from "../../assets/contexts/callBackContext";


function Header({ headerRef, blackBannerRef }) {
  const { setCallBackPopupOpen } = useContext(CallBackContext)
  const scrollDirection = useScrollDirection();
  const { width } = useWindowSize();
  const [searchOpen, setSearchOpen] = useState(false)

  const config = useContext(ConfigContext);
  const cart_context = useContext(CartContext)
  const {
    cart,
    handleAddToCart,
    handleRemoveFromCart,
    setCart,
  } = cart_context
  const { initialConstants } = config
  const { FIRST_LEVEL_CATEGORIES, HEADER_LINKS } = initialConstants

  const catalogBtnRef = useRef(null);
  const linksRef = useRef(null);

  const [isCatalogOpen, setCatalogOpen] = useState(false);
  // const [categories, setCategories] = useState(FIRST_LEVEL_CATEGORIES && FIRST_LEVEL_CATEGORIES.length > 0 && Array.isArray(FIRST_LEVEL_CATEGORIES) ? FIRST_LEVEL_CATEGORIES : []);
  const [topCategories, setTopCategories] = useState(undefined);

  // useEffect(() => {
  //   mainApi
  //     .getCategories({
  //       limit: 25,
  //       shop_id: "65ae789bcb5f6a9f66e457aa",
  //     })
  //     .then((res) => {
  //       console.log(res.data);
  //       setCategories(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  const [isMenuOpen, setMenuOpen] = useState(false);

  const [scrollWindowPosition, setScrollWindowPosition] = useState(0);
  const [popupScrollPosition, setPopupScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;

    setScrollWindowPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.top = `-${scrollWindowPosition}px`;
      setPopupScrollPosition(scrollWindowPosition);
      setTimeout(() => {
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.height = "100%";
      }, 10);

      console.log(window.pageYOffset);
    } else {
      document.body.style.overflow = "unset";
      document.body.style.position = "unset";
      document.body.style.width = "unset";
      document.body.style.height = "unset";
      document.body.style.top = `unset`;
      console.log(popupScrollPosition);
      window.scrollTo(0, popupScrollPosition);
      setScrollWindowPosition(popupScrollPosition);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuOpen]);

  const [visibleCategories, setVisibleCategories] = useState([]);

  useEffect(() => {
    if (!HEADER_LINKS || HEADER_LINKS.length === 0) return
    const updateVisibleLinks = () => {
      if (linksRef.current) {
        const maxAllowedWidth = linksRef.current.offsetWidth;
        if (maxAllowedWidth <= 0) return
        let totalWidth = 0;
        const linksToShow = [];

        HEADER_LINKS.forEach((link, index) => {
          const linkElement = document.createElement('div');
          linkElement.className = 'link';
          linkElement.style.visibility = 'hidden';
          linkElement.style.position = 'absolute';
          linkElement.innerText = link.name;
          document.body.appendChild(linkElement);
          const linkWidth = linkElement.offsetWidth + 28 * 2;
          document.body.removeChild(linkElement);

          if (totalWidth + linkWidth <= maxAllowedWidth) {
            linksToShow.push(link);
            totalWidth += linkWidth;
          }
        });

        setVisibleCategories(linksToShow);
      }
    };

    updateVisibleLinks();
    window.addEventListener('resize', updateVisibleLinks);

    return () => window.removeEventListener('resize', updateVisibleLinks);
  }, [HEADER_LINKS]);

  const [isLangOpen, setLangOpen] = useState(false)
  const location = useLocation()
  const [headerIsOverBlack, setHeaderIsOverBlack] = useState(location.pathname === '/' || location.pathname === `/${SELL_TO_US_PAGE_LINK}`);

  useEffect(() => {
    setHeaderIsOverBlack(location.pathname === '/' || location.pathname === `/${SELL_TO_US_PAGE_LINK}`)
  }, [location]);

  useEffect(() => {
    if (location.pathname !== '/' && location.pathname !== `/${SELL_TO_US_PAGE_LINK}`) {
      setHeaderIsOverBlack(false)
      return
    }
    const onScroll = () => {
      if (!headerRef.current || !blackBannerRef.current) return;

      const headerRect = headerRef.current.getBoundingClientRect();
      const blackRect = blackBannerRef.current.getBoundingClientRect();

      const isOverlapping =
        headerRect.bottom > blackRect.top &&
        headerRect.top < blackRect.bottom;

      setHeaderIsOverBlack(isOverlapping);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // Initial check
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [headerRef, blackBannerRef, location]);

  // useEffect(() => {
  //   // Update header styling dynamically
  //   if (headerRef.current) {
  //     if (headerIsOverBlack) {
  //       headerRef.current.classList.add('header--over-black');
  //     } else {
  //       headerRef.current.classList.remove('header--over-black');
  //     }
  //   }
  // }, [headerIsOverBlack, headerRef]);

  const langSelectorRef = useRef()

  useEffect(() => {
    // Only attach the listener if search is currently open
    if (!isLangOpen) return;

    const handleClickOutside = (e) => {
      // If the click is outside the searchRef area, close the search
      if (langSelectorRef.current && !langSelectorRef.current.contains(e.target)) {
        setLangOpen(false)
      }
    };

    // Attach the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when the component unmounts or searchOpen changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLangOpen, setLangOpen, langSelectorRef]);

  return (
    <>

      <header ref={headerRef} className={`header ${headerIsOverBlack ? 'header_black' : ''}  ${scrollDirection === "down" ? searchOpen || location.pathname === `/${ABOUT_US_PAGE_LINK}` ? "header_show" : "header_hide" : "header_show"}`}>

        <CatalogDrop
          isOpened={isCatalogOpen}
          setOpened={setCatalogOpen}
          categories={FIRST_LEVEL_CATEGORIES}
          catalogBtnRef={catalogBtnRef}
        />
        <MenuPopup
          isOpened={isMenuOpen}
          setOpened={setMenuOpen}
          categories={FIRST_LEVEL_CATEGORIES}
        />
        <div className="header__content">
          <div className="header__menu-and-search-mobile">
            <button
              className="header__menu"
              type="button"
              onClick={() => {
                setMenuOpen(true);
              }}
            >
              <MenuIcon
                mainClassName={"header__menu-icon"}
                strokeClassName={"header__menu-icon-stroke"}
              />
            </button>
            <button className="header__search-icon-mobile" onClick={() => setSearchOpen(true)} type="button">
              <SearchIcon mainClassName={'header__input-icon'} strokeClassName={'header__input-icon-stroke'} />
            </button>
          </div>

          <Link to={"/"} className="header__content__logos">
            <div className="header__logo header__logo_pc">
              <LogoIcon
                mainClassName={'header__logo-img'}
                fillClassName={'header__logo-img-fill'}
              />
            </div>
          </Link>

          <Link to={'/'} className="header__content__logos_mobile">
            <div className="header__logo header__logo_mobile">
              <LogoIcon
                mainClassName={'header__logo-img'}
                fillClassName={'header__logo-img-fill'}
              />
            </div>
          </Link>

          <div className="header__catalog-with-links">
            {width > 1060 ?
              <div className="search_pc">
                <button className="header__input-icon" onClick={() => setSearchOpen(true)} type="button">
                  <SearchIcon mainClassName={'header__input-icon'} strokeClassName={'header__input-icon-stroke'} />
                </button>
                <Search searchOpen={searchOpen} setSearchOpen={setSearchOpen} maxWidth={linksRef && linksRef.current ? linksRef.current.offsetWidth + 28 + 20 + (width > 1215 ? (22 + 4) : (0)) : '700px'} />
              </div>
              :
              null}

            {HEADER_LINKS && HEADER_LINKS.length > 0 ?
              <div className="header__links" ref={linksRef}>
                {HEADER_LINKS.map((link) => {
                  if (isExternalURL(link.url)) {
                    return (
                      <Link
                        key={link._id}
                        className={`header__link`}
                        to={link.url}
                        target={'_blank'} // Conditionally set target attribute
                        rel={'noopener noreferrer'} // Add rel for security if external
                      >
                        {link.name}
                      </Link>
                    )
                  } else {
                    const relativePath = getURLRelativePath(link.url);
                    return (
                      <NavLink
                        key={link._id}
                        className={({ isActive }) => {
                          return `header__link ${isActive ? 'header__link_active' : ''}`
                        }}
                        to={relativePath}
                      >
                        {link.name}
                        {/* <svg className="header__link__active-triangle" xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0L0 14L10 28L20 14L10 0Z" fill="#6CCDF7" />
                        </svg> */}
                      </NavLink>
                    )
                  }
                })}
                <button className="header__contact" type='button' onClick={() => {
                  setCallBackPopupOpen(true)
                }}>
                  <svg className="header__contact-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="header__contact-icon-fill" fill-rule="evenodd" clip-rule="evenodd" d="M17 16.9998C19.7614 16.9998 22 14.7612 22 11.9998C22 9.23833 19.7614 6.99976 17 6.99976C14.2386 6.99976 12 9.23833 12 11.9998C12 14.7612 14.2386 16.9998 17 16.9998ZM17.75 9.99976C17.75 9.58554 17.4142 9.24976 17 9.24976C16.5858 9.24976 16.25 9.58554 16.25 9.99976V11.8459C16.25 12.0264 16.3151 12.2007 16.4332 12.3371L17.4332 13.491C17.7045 13.804 18.1782 13.8378 18.4912 13.5665C18.8042 13.2952 18.838 12.8216 18.5668 12.5086L17.75 11.5661V9.99976Z" fill="white" />
                    <path className="header__contact-icon-fill" fill-rule="evenodd" clip-rule="evenodd" d="M1.25 6.99976C1.25 6.58554 1.58579 6.24976 2 6.24976H10C10.4142 6.24976 10.75 6.58554 10.75 6.99976C10.75 7.41397 10.4142 7.74976 10 7.74976H2C1.58579 7.74976 1.25 7.41397 1.25 6.99976ZM1.25 11.9998C1.25 11.5855 1.58579 11.2498 2 11.2498H8C8.41421 11.2498 8.75 11.5855 8.75 11.9998C8.75 12.414 8.41421 12.7498 8 12.7498H2C1.58579 12.7498 1.25 12.414 1.25 11.9998ZM1.25 16.9998C1.25 16.5855 1.58579 16.2498 2 16.2498H10C10.4142 16.2498 10.75 16.5855 10.75 16.9998C10.75 17.414 10.4142 17.7498 10 17.7498H2C1.58579 17.7498 1.25 17.414 1.25 16.9998Z" fill="white" />
                  </svg>
                  Связаться с нами
                </button>
              </div>
              : null}
          </div>

          <div className="header__cart-and-menu">

            <div className="header__lang-selector" ref={langSelectorRef}>
              <button className={`header__lang-selector-selected ${isLangOpen ? 'header__lang-selector-selected_active' : ''}`} type="button" onClick={() => {
                setLangOpen(prevValue => !prevValue)
              }}>
                <p className="header__lang-selector-selected-text">RU</p>
                <LAND_DROP_ARROW
                  mainClassName={'header__lang-selector-selected-arrow'}
                  fillClassName={'header__lang-selector-selected-arrow-fill'}
                />
              </button>
              {isLangOpen ?
                <motion.div
                  className='header__lang-dropdown'
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                >
                  <a className="header__lang-dropdown-item" href={EN_SITE_URL}>
                    EN
                  </a>
                  <a className="header__lang-dropdown-item" href={RU_SITE_URL}>
                    RU
                  </a>
                  {/* <button onClick={() => selectLanguage(EN_LANGUAGE)} className={`header__control-language ${language === EN_LANGUAGE ? 'header__control-language_selected' : ''}`}>
                    {LANGUAGES.EN.flag}
                    {LANGUAGES.EN.lang}
                  </button>
                  <button onClick={() => selectLanguage(BG_LANGUAGE)} className={`header__control-language ${language === BG_LANGUAGE ? 'header__control-language_selected' : ''}`}>
                    {LANGUAGES.BG.flag}
                    {LANGUAGES.BG.lang}
                  </button> */}
                </motion.div>
                : null}
            </div>



            <button className="header__contact-mobile" type='button' onClick={() => {
              setCallBackPopupOpen(true)
            }}>
              <svg className="header__contact-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="header__contact-icon-fill" fill-rule="evenodd" clip-rule="evenodd" d="M17 16.9998C19.7614 16.9998 22 14.7612 22 11.9998C22 9.23833 19.7614 6.99976 17 6.99976C14.2386 6.99976 12 9.23833 12 11.9998C12 14.7612 14.2386 16.9998 17 16.9998ZM17.75 9.99976C17.75 9.58554 17.4142 9.24976 17 9.24976C16.5858 9.24976 16.25 9.58554 16.25 9.99976V11.8459C16.25 12.0264 16.3151 12.2007 16.4332 12.3371L17.4332 13.491C17.7045 13.804 18.1782 13.8378 18.4912 13.5665C18.8042 13.2952 18.838 12.8216 18.5668 12.5086L17.75 11.5661V9.99976Z" fill="white" />
                <path className="header__contact-icon-fill" fill-rule="evenodd" clip-rule="evenodd" d="M1.25 6.99976C1.25 6.58554 1.58579 6.24976 2 6.24976H10C10.4142 6.24976 10.75 6.58554 10.75 6.99976C10.75 7.41397 10.4142 7.74976 10 7.74976H2C1.58579 7.74976 1.25 7.41397 1.25 6.99976ZM1.25 11.9998C1.25 11.5855 1.58579 11.2498 2 11.2498H8C8.41421 11.2498 8.75 11.5855 8.75 11.9998C8.75 12.414 8.41421 12.7498 8 12.7498H2C1.58579 12.7498 1.25 12.414 1.25 11.9998ZM1.25 16.9998C1.25 16.5855 1.58579 16.2498 2 16.2498H10C10.4142 16.2498 10.75 16.5855 10.75 16.9998C10.75 17.414 10.4142 17.7498 10 17.7498H2C1.58579 17.7498 1.25 17.414 1.25 16.9998Z" fill="white" />
              </svg>
            </button>
            <Link className="header__favorite" to={`/${FAVORITE_LINK}`}>
              <svg className='header__favorite-icon' width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className='header__favorite-icon-fill-and-stroke' d="M17.5173 3C21.3979 3 24 6.725 24 10.1938C24 17.235 13.1968 23 13 23C12.8032 23 2 17.235 2 10.1938C2 6.725 4.60211 3 8.48267 3C10.701 3 12.1579 4.13125 13 5.13875C13.8421 4.13125 15.299 3 17.5173 3Z" fill="white" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </Link>
            <div className="header__cart-box">
              {cart && cart.length > 0 ? (
                <p className="header__cart-count">{cart.length}</p>
              ) : null}
              <Link className="header__cart" to={`/${CART_MAIN_LINK}`}>
                {/* <h3 className="header__cart-text">Корзина</h3> */}
                <CartIcon
                  mainClassName={"header__cart-icon"}
                  strokeClassName={"header__cart-icon-stroke"}
                />
              </Link>
            </div>
            {/* <button
              className="header__menu"
              type="button"
              onClick={() => {
                setMenuOpen(true);
              }}
            >
              <MenuIcon
                mainClassName={"header__menu-icon"}
                strokeClassName={"header__menu-icon-stroke"}
              />
            </button> */}
          </div>



        </div>
        {width <= 1060 ?
          <div className="search_mobile">
            <Search searchOpen={searchOpen} setSearchOpen={setSearchOpen} maxWidth={`100%`} />
          </div>
          : null}
      </header>
    </>
  );
}

export default Header;
